import HardBreak from '@tiptap/extension-hard-break';

export const HardBreakNode = HardBreak.extend({
  name: 'hard_break',
});
